import React, { useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import { Translate } from "react-redux-i18n";
import NodeBase from "../../../components/NodeBase";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Icons, DialogHandler } from "cakemail-ui-components/lib/react";
import { openSubScene } from "assets/js/data/automations/actions";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";

const StripeChargeSucceededEventNode = (props) => {
	const [styles, setStyles] = useState();
	useLayoutEffect(() => {
		if (
			document.getElementsByClassName("helperTrigger").length > 0 &&
			document.getElementsByClassName("manual").length > 0
		) {
			const subWidth =
				document.getElementsByClassName("helperTrigger")[0].clientHeight;
			const manualWidth =
				document.getElementsByClassName("manual")[0].clientHeight;
			if (subWidth > manualWidth) {
				setStyles({
					display: "flex",
					alignItems: "flex-end",
					minHeight: `${subWidth}px`,
				});
			}
		}
	});

	return (
		<>
			<NodeBase
                footerIcon="icon-trigger-framed"
				showHeader={true}
				footerStats={null}
				showFooter={true}
				styles={styles ? styles : null}
				content={
					<p>
						<b><Translate value="app-automation-editor_events_trigger-chargeSucceeded_desc"/></b>
					</p>
                }
				{...props}
			/>
		</>
	);
};

StripeChargeSucceededEventNode.propTypes = {
	list: PropTypes.shape({
		name: PropTypes.string,
	}),
};
export default connect(
	(state, props) => {
		return {
			account: state.global.account,
			lists: state.lists?.lists?.data,
			list: state.lists?.lists?.data?.filter(
				(list) => list.id === props.data.audience
			)[0],
			stats: state.automations.stats.subscribers,
			activeAutomation: state.automations.activeAutomation,
		};
	},
	(dispatch) =>
		bindActionCreators(
			{
				openSubScene,
				//listLists,
			},
			dispatch
		)
)(StripeChargeSucceededEventNode);